import { syncNavActive } from './nav';

var mqHorizontal = window.matchMedia('(min-width: 1024px)');
var wheelListenerAttached = false;
var pointerListenerAttached = false;
var WHEEL_SNAP_COOLDOWN_MS = 650;
var wheelSnapTimer = null;
var track = null;
var screens = [];
var scrollRoot = null;
var swipeState = null;
var suppressClickUntil = 0;

var SWIPE_START_PX = 8;
var SWIPE_DRAG_MIN_PX = 4;
var SWIPE_DRAG_RATIO_COMMIT = 0.08;
var SWIPE_DRAG_RATIO_STEP = 0.035;
var SWIPE_DRAG_PX_STEP = 12;
var SWIPE_FLICK_PX = 20;
var SWIPE_FLICK_MS = 500;
var SWIPE_HORIZONTAL_BIAS = 0.65;
var SWIPE_VERTICAL_BIAS = 1.35;
var SWIPE_VERTICAL_MIN_PX = 14;
var SWIPE_COMMIT_PX = 12;

function deltaToPixels(e, axis) {
    var raw = axis === 'x' ? e.deltaX : e.deltaY;
    switch (e.deltaMode) {
        case 1:
            return raw * 16;
        case 2:
            return raw * (axis === 'x' ? getScrollRoot().clientWidth : getScrollRoot().clientHeight);
        default:
            return raw;
    }
}

function getScrollRoot() {
    if (!scrollRoot) {
        scrollRoot = document.querySelector('[data-museum-scroll]') || document.documentElement;
    }

    return scrollRoot;
}

function getSectionWidth() {
    return getScrollRoot().clientWidth;
}

function getActiveIndex() {
    if (!track) {
        return 0;
    }

    var activeId = track.getAttribute('data-active');

    if (activeId === 'exhibitions') {
        activeId = 'heroes';
    }

    var index = 0;

    screens.forEach(function (screen, i) {
        if (screen.getAttribute('data-museum-screen') === activeId) {
            index = i;
        }
    });

    return index;
}

function syncMobileSectionAria() {
    if (!track || !screens.length) {
        return;
    }

    if (!mqHorizontal.matches) {
        screens.forEach(function (s) {
            s.setAttribute('aria-hidden', 'false');
        });
    }
}

function applyScreenMeta(screen) {
    if (!screen) {
        return;
    }

    var title = screen.getAttribute('data-museum-title');
    var description = screen.getAttribute('data-museum-description');
    var url = screen.getAttribute('data-museum-url');

    if (title) {
        document.title = title;
    }

    if (description !== null) {
        var meta = document.querySelector('meta[name="description"]');

        if (description) {
            if (!meta) {
                meta = document.createElement('meta');
                meta.setAttribute('name', 'description');
                document.head.appendChild(meta);
            }

            meta.setAttribute('content', description);
        } else if (meta) {
            meta.remove();
        }
    }

    if (url) {
        syncNavActive(url);
    }
}

function setActiveScreen(index) {
    if (!track || !screens.length) {
        return;
    }

    var screen = screens[index];
    if (!screen) {
        return;
    }

    var screenId = screen.getAttribute('data-museum-screen');
    track.setAttribute('data-active', screenId);

    if (mqHorizontal.matches) {
        screens.forEach(function (item, i) {
            item.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
    } else {
        syncMobileSectionAria();
    }

    var url = screen.getAttribute('data-museum-url');

    if (url) {
        history.replaceState({ museumScreen: screenId }, '', url);
    }

    applyScreenMeta(screen);
}

function scrollToIndex(index, smooth) {
    var el = getScrollRoot();
    var sectionWidth = getSectionWidth();
    var maxIndex = Math.max(0, screens.length - 1);
    var targetIndex = Math.max(0, Math.min(maxIndex, index));

    el.scrollTo({
        left: targetIndex * sectionWidth,
        behavior: smooth ? 'smooth' : 'auto'
    });

    setActiveScreen(targetIndex);
}

function scrollToActiveScreen(smooth) {
    scrollToIndex(getActiveIndex(), smooth);
}

function normalizePath(path) {
    if (!path) {
        return '/';
    }

    var normalized = String(path).split('?')[0].split('#')[0];

    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
        normalized = normalized.slice(0, -1);
    }

    return normalized || '/';
}

function getIndexForUrl(href) {
    var targetPath;

    try {
        targetPath = normalizePath(new URL(href, window.location.href).pathname);
    } catch (err) {
        return -1;
    }

    for (var i = 0; i < screens.length; i++) {
        var screenUrl = screens[i].getAttribute('data-museum-url');

        if (!screenUrl) {
            continue;
        }

        try {
            if (normalizePath(new URL(screenUrl, window.location.href).pathname) === targetPath) {
                return i;
            }
        } catch (err) {
            if (normalizePath(screenUrl) === targetPath) {
                return i;
            }
        }
    }

    return -1;
}

/**
 * Мобильная «одна лента»: скролл к первой секции, совпадающей с путём URL, и обновление history.
 */
function scrollMobileToCarouselSection(href, smooth, useReplace) {
    var index = getIndexForUrl(href);
    if (index < 0 || !screens[index]) {
        return false;
    }

    var section = screens[index];
    section.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });

    var screenId = section.getAttribute('data-museum-screen');
    track.setAttribute('data-active', screenId);
    syncMobileSectionAria();

    var historyUrl;

    try {
        var u = new URL(href, window.location.href);
        historyUrl = u.pathname + u.search + u.hash;
    } catch (err) {
        historyUrl = href;
    }

    if (useReplace) {
        history.replaceState({ museumScreen: screenId }, '', historyUrl);
    } else {
        history.pushState({ museumScreen: screenId }, '', historyUrl);
    }

    applyScreenMeta(section);

    return true;
}

function scrollToCarouselSectionFromLocation() {
    if (mqHorizontal.matches || !track) {
        return;
    }

    syncMobileSectionAria();

    window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
            scrollMobileToCarouselSection(window.location.href, false, true);
        });
    });
}

function navigateToUrl(href, smooth) {
    var index = getIndexForUrl(href);

    if (index < 0) {
        return false;
    }

    if (mqHorizontal.matches) {
        scrollToIndex(index, smooth);
    } else {
        scrollMobileToCarouselSection(href, smooth, false);
    }

    return true;
}

function closeMobileNav() {
    var nav = document.querySelector('[data-museum-nav]');
    var toggle = document.querySelector('[data-museum-nav-toggle]');

    if (!nav || !nav.classList.contains('is-open')) {
        return;
    }

    nav.classList.remove('is-open');

    if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
    }
}

function tryHandleCarouselNavLink(e, link) {
    if (!link || !track) {
        return false;
    }

    if (link.target === '_blank' || link.hasAttribute('download')) {
        return false;
    }

    var href = link.getAttribute('href');

    if (!href || href.charAt(0) === '#') {
        return false;
    }

    if (getIndexForUrl(link.href) < 0) {
        return false;
    }

    e.preventDefault();

    if (mqHorizontal.matches) {
        navigateToUrl(link.href, true);
    } else {
        scrollMobileToCarouselSection(link.href, true, false);
    }

    closeMobileNav();
    return true;
}

function onHeaderNavClick(e) {
    var link = e.target.closest && e.target.closest('a[href]');

    if (!link) {
        return;
    }

    var header = document.querySelector('[data-museum-header]');

    if (!header || !header.contains(link)) {
        return;
    }

    tryHandleCarouselNavLink(e, link);
}

function onMenuCaptureClick(e) {
    if (mqHorizontal.matches) {
        return;
    }

    var menu = document.querySelector('[data-museum-menu]');
    if (!menu) {
        return;
    }

    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || !menu.contains(link)) {
        return;
    }

    tryHandleCarouselNavLink(e, link);
}

function initCarouselNav() {
    var header = document.querySelector('[data-museum-header]');

    if (!track) {
        return;
    }

    if (header) {
        header.addEventListener('click', onHeaderNavClick);
    }

    var menu = document.querySelector('[data-museum-menu]');
    if (menu) {
        menu.addEventListener('click', onMenuCaptureClick, true);
    }
}

function onPopState() {
    if (mqHorizontal.matches || !track) {
        return;
    }

    scrollMobileToCarouselSection(window.location.href, false, true);
}

function onWheelDesktop(e) {
    if (!mqHorizontal.matches || !track || e.ctrlKey || e.metaKey) {
        return;
    }

    var el = getScrollRoot();
    var t = e.target;
    var elTarget = t && t.nodeType === 1 ? t : t && t.parentElement;

    if (elTarget && elTarget.closest && elTarget.closest('input, textarea, select, [contenteditable="true"]')) {
        return;
    }

    var dy = deltaToPixels(e, 'y');
    var dx = deltaToPixels(e, 'x');
    var verticalScroll = elTarget && elTarget.closest && elTarget.closest('[data-museum-vertical-scroll]');

    if (verticalScroll && dy !== 0) {
        var maxScrollTop = verticalScroll.scrollHeight - verticalScroll.clientHeight;
        var canScrollUp = verticalScroll.scrollTop > 1;
        var canScrollDown = verticalScroll.scrollTop < maxScrollTop - 1;

        if ((dy > 0 && canScrollDown) || (dy < 0 && canScrollUp)) {
            return;
        }
    }

    var maxLeft = el.scrollWidth - el.clientWidth;
    var delta = Math.abs(dx) > Math.abs(dy) ? dx : dy;

    if (maxLeft > 1) {
        if (delta === 0 || wheelSnapTimer) {
            e.preventDefault();
            return;
        }

        e.preventDefault();

        var sectionWidth = getSectionWidth();
        var currentIndex = Math.round(el.scrollLeft / sectionWidth);
        var maxIndex = screens.length - 1;
        var targetIndex = Math.max(0, Math.min(maxIndex, currentIndex + (delta > 0 ? 1 : -1)));

        scrollToIndex(targetIndex, true);
        lockSnapCooldown();

        return;
    }

    if (dy !== 0 || dx !== 0) {
        e.preventDefault();
    }
}

function getEventTargetElement(target) {
    return target && target.nodeType === 1 ? target : target && target.parentElement;
}

function findVerticalScroll(target) {
    var el = getEventTargetElement(target);

    return el && el.closest ? el.closest('[data-museum-vertical-scroll]') : null;
}

function verticalScrollCanConsume(verticalScroll, deltaY) {
    if (!verticalScroll || deltaY === 0) {
        return false;
    }

    var maxScrollTop = verticalScroll.scrollHeight - verticalScroll.clientHeight;

    if (maxScrollTop <= 1) {
        return false;
    }

    if (deltaY > 0) {
        return verticalScroll.scrollTop < maxScrollTop - 1;
    }

    return verticalScroll.scrollTop > 1;
}

function isSnapLocked() {
    return !!wheelSnapTimer;
}

function lockSnapCooldown() {
    wheelSnapTimer = window.setTimeout(function () {
        wheelSnapTimer = null;
    }, WHEEL_SNAP_COOLDOWN_MS);
}

function swipeDirection(state) {
    var deltaScroll = getScrollRoot().scrollLeft - state.startScrollLeft;
    var deltaX = state.lastX - state.startX;

    if (Math.abs(deltaScroll) >= 8) {
        return deltaScroll > 0 ? 1 : -1;
    }

    if (Math.abs(deltaX) >= SWIPE_START_PX) {
        return deltaX < 0 ? 1 : -1;
    }

    return 0;
}

function resolveSwipeTargetIndex(state) {
    var el = getScrollRoot();
    var sectionWidth = getSectionWidth();
    var maxIndex = Math.max(0, screens.length - 1);
    var startIndex = state.baseIndex;
    var scrollLeft = el.scrollLeft;
    var deltaScroll = scrollLeft - state.startScrollLeft;
    var deltaX = state.lastX - state.startX;
    var dragRatio = Math.abs(deltaScroll) / sectionWidth;
    var nearestIndex = Math.round(scrollLeft / sectionWidth);
    var direction = swipeDirection(state);
    var isFlick =
        Math.abs(deltaX) >= SWIPE_FLICK_PX && Date.now() - state.startTime <= SWIPE_FLICK_MS;
    var targetIndex;

    if (
        direction !== 0 &&
        (Math.abs(deltaX) >= SWIPE_COMMIT_PX ||
            dragRatio >= SWIPE_DRAG_RATIO_STEP ||
            Math.abs(deltaX) >= SWIPE_DRAG_PX_STEP ||
            isFlick)
    ) {
        targetIndex = startIndex + direction;
    } else if (dragRatio >= SWIPE_DRAG_RATIO_COMMIT) {
        targetIndex = nearestIndex;
    } else if (dragRatio < 0.04 && Math.abs(deltaX) < SWIPE_COMMIT_PX) {
        targetIndex = startIndex;
    } else {
        targetIndex = nearestIndex;
    }

    return Math.max(0, Math.min(maxIndex, targetIndex));
}

function shouldYieldToVerticalScroll(dx, dy, verticalScroll) {
    if (!verticalScroll) {
        return false;
    }

    var absDx = Math.abs(dx);
    var absDy = Math.abs(dy);

    return (
        absDy >= SWIPE_VERTICAL_MIN_PX &&
        absDy > absDx * SWIPE_VERTICAL_BIAS &&
        verticalScrollCanConsume(verticalScroll, dy)
    );
}

function canStartHorizontalDrag(dx, dy, verticalScroll) {
    var absDx = Math.abs(dx);
    var absDy = Math.abs(dy);

    if (!verticalScroll) {
        return absDx >= SWIPE_DRAG_MIN_PX || absDx >= absDy;
    }

    if (absDx >= SWIPE_START_PX && absDx >= absDy * SWIPE_HORIZONTAL_BIAS) {
        return true;
    }

    return absDx >= SWIPE_START_PX && absDx >= absDy;
}

function hasHorizontalSwipeIntent(state, dx, dy) {
    var scrollDelta = getScrollRoot().scrollLeft - state.startScrollLeft;
    var sectionWidth = getSectionWidth();

    return (
        state.isDragging ||
        state.lockAxis === 'h' ||
        Math.abs(dx) >= SWIPE_COMMIT_PX ||
        Math.abs(scrollDelta) >= sectionWidth * 0.02 ||
        (Math.abs(dx) > Math.abs(dy) * 0.55 && Math.abs(dx) >= SWIPE_START_PX)
    );
}

function startHorizontalDrag(e) {
    if (!swipeState || swipeState.isDragging) {
        return;
    }

    swipeState.isDragging = true;
    swipeState.lockAxis = 'h';

    var el = getScrollRoot();
    el.classList.add('museum-scroll--dragging');

    try {
        el.setPointerCapture(e.pointerId);
    } catch (err) {
        // ignore
    }
}

function detachSwipeListeners() {
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', onPointerUp);
    window.removeEventListener('pointercancel', onPointerCancel);
}

function commitSwipeGesture(state, suppressClick) {
    if (!state) {
        return;
    }

    if (suppressClick) {
        suppressClickUntil = Date.now() + 400;
    }

    if (!isSnapLocked()) {
        scrollToIndex(resolveSwipeTargetIndex(state), true);
        lockSnapCooldown();
    } else {
        scrollToIndex(getActiveIndex(), true);
    }
}

function endSwipe(commit) {
    if (!swipeState) {
        return;
    }

    var state = swipeState;

    swipeState = null;
    getScrollRoot().classList.remove('museum-scroll--dragging');
    detachSwipeListeners();

    if (!commit) {
        return;
    }

    commitSwipeGesture(state, true);
}

function onPointerDown(e) {
    if (!mqHorizontal.matches || !track || isSnapLocked()) {
        return;
    }

    if (e.pointerType === 'mouse' && e.button !== 0) {
        return;
    }

    var elTarget = getEventTargetElement(e.target);

    if (
        elTarget &&
        elTarget.closest &&
        elTarget.closest('input, textarea, select, button, label, [contenteditable="true"]')
    ) {
        return;
    }

    var verticalScroll = findVerticalScroll(e.target);

    swipeState = {
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        lastX: e.clientX,
        prevX: e.clientX,
        lastY: e.clientY,
        startScrollLeft: getScrollRoot().scrollLeft,
        baseIndex: Math.round(getScrollRoot().scrollLeft / getSectionWidth()),
        isDragging: false,
        lockAxis: verticalScroll ? null : 'h',
        verticalScroll: verticalScroll,
        startTime: Date.now(),
        lastTime: Date.now(),
        prevTime: Date.now(),
    };

    window.addEventListener('pointermove', onPointerMove, { passive: false });
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerCancel);
}

function onPointerMove(e) {
    if (!swipeState || e.pointerId !== swipeState.pointerId) {
        return;
    }

    var dx = e.clientX - swipeState.startX;
    var dy = e.clientY - swipeState.startY;
    var now = Date.now();

    if (!swipeState.isDragging) {
        if (shouldYieldToVerticalScroll(dx, dy, swipeState.verticalScroll)) {
            endSwipe(false);
            return;
        }

        if (!canStartHorizontalDrag(dx, dy, swipeState.verticalScroll)) {
            if (Math.hypot(dx, dy) < SWIPE_START_PX) {
                return;
            }

            return;
        }

        swipeState.lockAxis = 'h';
        startHorizontalDrag(e);
    }

    e.preventDefault();

    var scrollEl = getScrollRoot();
    var maxLeft = scrollEl.scrollWidth - scrollEl.clientWidth;
    var nextLeft = swipeState.startScrollLeft - dx;

    scrollEl.scrollLeft = Math.max(0, Math.min(maxLeft, nextLeft));

    swipeState.prevX = swipeState.lastX;
    swipeState.prevTime = swipeState.lastTime;
    swipeState.lastX = e.clientX;
    swipeState.lastY = e.clientY;
    swipeState.lastTime = now;
}

function onPointerUp(e) {
    if (!swipeState || e.pointerId !== swipeState.pointerId) {
        return;
    }

    var state = swipeState;
    var dx = e.clientX - state.startX;
    var dy = e.clientY - state.startY;

    state.lastX = e.clientX;
    state.lastY = e.clientY;

    swipeState = null;
    getScrollRoot().classList.remove('museum-scroll--dragging');
    detachSwipeListeners();

    if (shouldYieldToVerticalScroll(dx, dy, state.verticalScroll) && !state.isDragging && state.lockAxis !== 'h') {
        return;
    }

    if (hasHorizontalSwipeIntent(state, dx, dy)) {
        commitSwipeGesture(state, state.isDragging || Math.abs(dx) >= SWIPE_DRAG_MIN_PX);
    }
}

function onPointerCancel(e) {
    if (!swipeState || e.pointerId !== swipeState.pointerId) {
        return;
    }

    endSwipe(swipeState.isDragging);
}

function onSwipeClickCapture(e) {
    if (Date.now() < suppressClickUntil) {
        e.preventDefault();
        e.stopPropagation();
    }
}

function getSwipeSurface() {
    return track || getScrollRoot();
}

function syncPointerListener() {
    var el = getSwipeSurface();
    var want = mqHorizontal.matches && !!track && el;

    if (want && !pointerListenerAttached) {
        el.addEventListener('pointerdown', onPointerDown, { capture: true });
        getScrollRoot().addEventListener('click', onSwipeClickCapture, true);
        pointerListenerAttached = true;
    } else if (!want && pointerListenerAttached && el) {
        el.removeEventListener('pointerdown', onPointerDown, { capture: true });
        getScrollRoot().removeEventListener('click', onSwipeClickCapture, true);
        pointerListenerAttached = false;
        endSwipe(false);
    }
}

function syncWheelListener() {
    var want = mqHorizontal.matches && !!track;

    if (want && !wheelListenerAttached) {
        window.addEventListener('wheel', onWheelDesktop, { passive: false });
        wheelListenerAttached = true;
    } else if (!want && wheelListenerAttached) {
        window.removeEventListener('wheel', onWheelDesktop, { passive: false });
        wheelListenerAttached = false;
    }

    syncPointerListener();
}

export function initHorizontalScroll() {
    track = document.querySelector('[data-museum-track]');
    scrollRoot = document.querySelector('[data-museum-scroll]');

    if (track) {
        screens = Array.prototype.slice.call(track.querySelectorAll('[data-museum-screen]'));

        if (mqHorizontal.matches) {
            scrollToActiveScreen(false);
        } else {
            syncMobileSectionAria();
            scrollToCarouselSectionFromLocation();
        }
    }

    window.addEventListener('popstate', onPopState);

    if (typeof mqHorizontal.addEventListener === 'function') {
        mqHorizontal.addEventListener('change', function () {
            syncWheelListener();
            syncPointerListener();

            if (track && mqHorizontal.matches) {
                scrollToActiveScreen(false);
            } else if (track) {
                syncMobileSectionAria();
                scrollToCarouselSectionFromLocation();
            }
        });
    } else if (typeof mqHorizontal.addListener === 'function') {
        mqHorizontal.addListener(function () {
            syncWheelListener();
            syncPointerListener();

            if (track && mqHorizontal.matches) {
                scrollToActiveScreen(false);
            } else if (track) {
                syncMobileSectionAria();
                scrollToCarouselSectionFromLocation();
            }
        });
    }

    syncWheelListener();
    syncPointerListener();
    initCarouselNav();
}
